var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized, msg } from '@lit/localize';
import { CommonActions } from '../../../localization/helpers.js';
let DuplicateNetworkForm = class DuplicateNetworkForm extends LitElement {
    // Dispatch event duplicate-network with new name
    handleSubmit() {
        const event = new CustomEvent('submit-duplicate-network', {
            detail: { newName: this.network.name },
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }
    handleCancel() {
        const event = new CustomEvent('cancel-duplicate-network', {
            bubbles: true,
            composed: true,
        });
        this.dispatchEvent(event);
    }
    handleInputChange(event) {
        this.network.name = event.detail; // Récupère la valeur depuis l'événement personnalisé
    }
    render() {
        return html `
      <div class="form-group">
        <label for="duplicate">${msg('Duplicated network name:', { id: 'network.duplicate.name', desc: 'Duplicated network name label' })}</label>
        <input-text
          id="duplicate"
          .value="${this.network?.name ? `${this.network.name}` : ''}"
          size="large"
          variant="secondary"
          placeholder=${msg('Enter a name for the duplicated network', { id: 'network.placeholder.duplicateName', desc: 'Duplicate name placeholder' })}
          @input-text="${this.handleInputChange}"
        ></input-text>
        <simple-checkbox
          .checked=${false}
          variant="secondary"
          label=${msg('Include network associated data (Zones, Distance matrices, ...)', { id: 'network.duplicate.includeData', desc: 'Include associated data checkbox' })}
        ></simple-checkbox>
      </div>
      <div class="buttons">
        <simple-button
          variant="secondary"
          @button-click="${this.handleCancel}"
          label=${CommonActions.cancel()}
        ></simple-button>
        <simple-button
          variant="primary"
          special
          @button-click="${this.handleSubmit}"
          label=${CommonActions.validate()}
        ></simple-button>
      </div>
    `;
    }
};
DuplicateNetworkForm.styles = css `
    :host {
      display: flex;
      flex-direction: column;
      gap: 10px;
      font-family: inherit;
      color: black;
    }

    .form-group {
      display: flex;
      flex-direction: column;
      gap: 10px; /* Ajoute un espacement entre les éléments */
    }

    label {
      font-size: 14px;
      margin-bottom: 5px;
      color: black;
    }

    input {
      padding: 8px;
      font-size: 22px;
      border: 1px solid #ccc;
      border-radius: 4px;
      background-color: white;
      font-weight: bold;
      color: #000;
    }

    .buttons {
      display: flex;
      justify-content: flex-end;
      gap: 10px;
    }
  `;
__decorate([
    property({ type: Object })
], DuplicateNetworkForm.prototype, "network", void 0);
DuplicateNetworkForm = __decorate([
    localized(),
    customElement('duplicate-network-form')
], DuplicateNetworkForm);
export { DuplicateNetworkForm };
//# sourceMappingURL=DuplicateNetworkForm.js.map